import type { OrganizationAlert } from '@/shared/hooks/api/regulatoryNews'
import { NewsroomAlertDetail } from './NewsroomAlertDetail'
import { NewsroomAlertList } from './NewsroomAlertList'

type NewsroomAlertsPanelProps = {
  alerts: OrganizationAlert[]
  selectedAlert: OrganizationAlert | null
  selectedAlertId: string | null
  isMarkReadPending: boolean
  onSelectAlert: (alertId: string) => void
  onMarkRead: (alertId: string) => void
  onRequestDismiss: (alertId: string) => void
}

export function NewsroomAlertsPanel({
  alerts,
  selectedAlert,
  selectedAlertId,
  isMarkReadPending,
  onSelectAlert,
  onMarkRead,
  onRequestDismiss,
}: NewsroomAlertsPanelProps) {
  return (
    <div className='grid min-h-[420px] overflow-hidden rounded-lg border lg:grid-cols-[minmax(0,0.5fr)_minmax(0,1.2fr)]'>
      <NewsroomAlertList
        alerts={alerts}
        selectedAlertId={selectedAlertId}
        onSelectAlert={onSelectAlert}
      />
      <div className='flex min-h-0 min-w-0 flex-col'>
        <NewsroomAlertDetail
          alert={selectedAlert}
          isMarkReadPending={isMarkReadPending}
          onMarkRead={onMarkRead}
          onRequestDismiss={onRequestDismiss}
        />
      </div>
    </div>
  )
}
